import styled from 'styled-components';
import { RadioGroup } from '@mui/material';

export const StyledRadioGroup = styled(RadioGroup)`
  .MuiFormControlLabel-root {
    .PrivateSwitchBase-root {
      .PrivateSwitchBase-input {
      }

      > span {
        > svg {
          color: var(--color-primary-blue) !important;

          > path {
            color: var(--color-primary-blue) !important;
          }
        }
      }
    }
  }
`;
